import React from 'react';
import './Socials.scss';

const Socials = () => {
    return (
        <div className="socials">
            <p className="socials__text me-3">Присоединяйтесь к нам:</p>
            <div className="socials__icons">
                <a target="blank" href="https://instagram.com/asklepiy.dv/">
                    <i className="bi bi-instagram me-3"></i>
                </a>
                <a target="blank" href="https://www.facebook.com/asklepiydv">
                    <i className="bi bi-facebook me-3"></i>
                </a>
                <a target="blank" href="http://vk.com/asklepiy_dv">
                    <i className="bi bi-bootstrap me-3"></i>
                </a>
                <a target="blank" href="https://www.youtube.com/channel/UCY6U5vxztPnS49WyF-cVxrg">
                    <i className="bi bi-youtube"></i>
                </a>
            </div>
        </div>
    );
};

export default Socials;